import $ from 'jquery';

export default class Placholder {
  constructor(element) {
    const $label = $('label', element);
    const $input = $('input, textarea', element);
    if ($label.length && $input.length) {
      const placeholder = $label.text().replace(':', '');
      $input.attr('placeholder', placeholder);
    }
  }
}



// WEBPACK FOOTER //
// ./Placeholder.js